import { render, staticRenderFns } from "./verify-link.vue?vue&type=template&id=572f3864&scoped=true&"
import script from "./verify-link.vue?vue&type=script&lang=js&"
export * from "./verify-link.vue?vue&type=script&lang=js&"
import style0 from "./verify-link.vue?vue&type=style&index=0&id=572f3864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f3864",
  null
  
)

export default component.exports